import { Checkbox, useField } from "@ark-ui/react";
import { ALL_FACILITY_STAFF_ROLES, FacilityStaffRole } from "@packages/core";
import { uniq } from "es-toolkit";
import { Merge } from "type-fest";

import { useTranslate } from "../../services";
import { css } from "../../styled-system/css";
import { CheckboxStyle, TypographyStyle } from "../common";

export type FacilityStaffRoleSelectorProperties = Merge<
  Checkbox.RootProps,
  {
    onChange: { (value: FacilityStaffRole, values: Array<FacilityStaffRole>): void };
    onBlur?: { (): void };
    options?: ReadonlyArray<FacilityStaffRole>;
    values: ReadonlyArray<FacilityStaffRole>;
  }
>;
export function FacilityStaffRoleSelector({
  onChange,
  onBlur,
  options = ALL_FACILITY_STAFF_ROLES,
  values,
}: FacilityStaffRoleSelectorProperties) {
  const field = useField();
  const translate = useTranslate();
  return (
    <div className={css({ display: "flex", flexDirection: "column", gap: "8px" })}>
      {options.map(function (option) {
        const checked = values.includes(option);
        return (
          <label
            className={css({ alignItems: "center", display: "flex", gap: "4px" })}
            key={option}
          >
            <input
              checked={checked}
              className={CheckboxStyle({ height: "16px" })}
              disabled={field.disabled}
              onBlur={function () {
                onBlur?.();
              }}
              onChange={function (event) {
                if (event.target.checked) {
                  onChange(option, uniq([...values, option] as const).sort());
                } else {
                  onChange(
                    option,
                    values.filter(function (value) {
                      return value !== option;
                    }),
                  );
                }
              }}
              type="checkbox"
            />
            <span className={TypographyStyle({ fontSize: "14px", lineHeight: 1 })}>
              {translate("%FacilityStaffRole." + option + ".0%")}
            </span>
          </label>
        );
      })}
    </div>
  );
}
